exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "@media (max-width: 800px){.src-components-leadgen-v2-ChatsForm-CrossMsg__container--3fL1A{padding:0px 5px}}.src-components-leadgen-v2-ChatsForm-CrossMsg__text--1lbmW{margin-top:-30px}@media (max-width: 800px){.src-components-leadgen-v2-ChatsForm-CrossMsg__text--1lbmW{margin-top:-15px}}.src-components-leadgen-v2-ChatsForm-CrossMsg__link--1y1TP{text-decoration:none;color:#18C7AF}\n", ""]);

// Exports
exports.locals = {
	"container": "src-components-leadgen-v2-ChatsForm-CrossMsg__container--3fL1A",
	"text": "src-components-leadgen-v2-ChatsForm-CrossMsg__text--1lbmW",
	"link": "src-components-leadgen-v2-ChatsForm-CrossMsg__link--1y1TP"
};